import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth0Context } from "../context/Auth0Context";
import TreeDataContext from "../context/TreeDataContext";
import TableContext from "../context/TableContext";
import AppOrgContext from "../context/AppOrgContext";
import WorkflowContext from "../context/WorkflowContext";
import AppBlocksContext from "../context/AppBlocksContext";
import FormContext from "../context/FormContext";
import EntityContext from "../context/EntityContext";
import StatemachineContext from "../context/StatemachineContext";
import ScreenContext from "../context/ScreenContext";
import TemplateContext from "../context/TemplateContext";
import { DBConnectorContext } from "../context/DBConnectorContext";
import CronContext from "../context/CronContext";
import APIContext from "../context/APIContext";
import AppUserContext from "../context/AppUserContext";
import VariableContext from "../context/VariableContext";
import LockContext from "../context/LockContext";
import PublicScreenContext from "../context/PublicScreenContext";
import NavigationContext from "../context/NavigationContext";
import Header from "../Layouts/Header/Header";
import ConnectorsContext from "../context/ConnectorsContext";
import { ROOT_ROUTE_SEGMENTS } from "./routesConstant";

const RequireAuth = () => {
  const { isAuthenticate, user } = useAuth0Context();
  const location = useLocation();
  if (!isAuthenticate) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page. state={{ from: location }}
    return <Navigate to="/" />;
  }

  const roles = user?.role_names || [];
  const userManagementPath = `/${ROOT_ROUTE_SEGMENTS.USER_MANAGEMENT}`;

  const hasUserAdmin = roles.includes("user-admin");
  const hasEditor = roles.includes("editor");
  const isOnlyUserAdmin = roles.length === 1 && hasUserAdmin;
  const isOnlyUserAdminAndEditor = roles.length === 2 && hasUserAdmin && hasEditor;
  const isRestrictedUser = isOnlyUserAdmin || isOnlyUserAdminAndEditor;

  if (isRestrictedUser && location.pathname !== userManagementPath) {
    return <Navigate to={userManagementPath} />;
  }

  return (
    <TreeDataContext>
      <TableContext>
        <AppOrgContext>
          <WorkflowContext>
            <AppBlocksContext>
              <FormContext>
                <EntityContext>
                  <StatemachineContext>
                    <ScreenContext>
                      <TemplateContext>
                        <DBConnectorContext>
                          <ConnectorsContext>
                            <CronContext>
                              <APIContext>
                                <AppUserContext>
                                  <VariableContext>
                                    <LockContext>
                                      <PublicScreenContext>
                                        <NavigationContext>
                                          <Header />
                                          <Outlet />
                                        </NavigationContext>
                                      </PublicScreenContext>
                                    </LockContext>
                                  </VariableContext>
                                </AppUserContext>
                              </APIContext>
                            </CronContext>
                          </ConnectorsContext>
                        </DBConnectorContext>
                      </TemplateContext>
                    </ScreenContext>
                  </StatemachineContext>
                </EntityContext>
              </FormContext>
            </AppBlocksContext>
          </WorkflowContext>
        </AppOrgContext>
      </TableContext>
    </TreeDataContext>
  );
};
export default RequireAuth;
